import { render, staticRenderFns } from "./chemProcessKnowhowDetailAekyung.vue?vue&type=template&id=6532ba59"
import script from "./chemProcessKnowhowDetailAekyung.vue?vue&type=script&lang=js"
export * from "./chemProcessKnowhowDetailAekyung.vue?vue&type=script&lang=js"
import style0 from "./chemProcessKnowhowDetailAekyung.vue?vue&type=style&index=0&id=6532ba59&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6532ba59')) {
      api.createRecord('6532ba59', component.options)
    } else {
      api.reload('6532ba59', component.options)
    }
    module.hot.accept("./chemProcessKnowhowDetailAekyung.vue?vue&type=template&id=6532ba59", function () {
      api.rerender('6532ba59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/msds/chemProcessKnowhowDetailAekyung.vue"
export default component.exports